import { Injectable } from '@angular/core';
import { OfflineOrderLoadListParams } from '@order/const';
import { OrderActions } from '@order/data-access';
import { OrderService } from './order.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineOrderService extends OrderService {
  loadOrderList(params: OfflineOrderLoadListParams): void {
    this.store.dispatch(
      new OrderActions.OfflineOrdersListLoad({
        ...params,
      }),
    );
  }

  loadOrderDetails(orderCode: string): void {
    this.store.dispatch(
      new OrderActions.OfflineOrderDetailsLoad({
        orderCode,
      }),
    );
  }

  repeatOrder(orderCode: string): void {
    this.store.dispatch(new OrderActions.OfflineOrderRepeat({ orderCode }));
  }
}
